import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, Upload, Calendar, Clock, MapPin, Package, CheckCircle2 } from 'lucide-react';
export function CreateShipment() {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white pb-24" data-id="element-558">
      <header className="px-4 py-6 border-b border-slate-100 flex items-center gap-4 bg-white sticky top-0 z-10 lg:px-8" data-id="element-559">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-560">
          <ArrowLeft size={24} data-id="element-561" />
        </button>
        <BilingualText en="Create New Shipment" ar="إنشاء شحنة جديدة" className="text-xl font-bold" data-id="element-562" />
      </header>

      <div className="p-4 lg:p-8 max-w-2xl mx-auto space-y-8" data-id="element-563">
        {/* Progress Steps */}
        <div className="flex justify-between relative px-2" data-id="element-564">
          <div className="absolute top-5 left-0 right-0 h-0.5 bg-slate-100 -z-10" data-id="element-565" />
          {[1, 2, 3].map(s => <div key={s} className={`w-10 h-10 rounded-full flex items-center justify-center font-bold border-4 border-white ${step >= s ? 'bg-[#2E3192] text-white' : 'bg-slate-200 text-slate-500'}`} data-id="element-566">
              {step > s ? <CheckCircle2 size={20} data-id="element-567" /> : s}
            </div>)}
        </div>

        {step === 1 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4" data-id="element-568">
            <BilingualText en="Shipment Details" ar="تفاصيل الشحنة" className="text-xl" data-id="element-569" />

            <div className="space-y-4" data-id="element-570">
              <div className="space-y-2" data-id="element-571">
                <BilingualText en="Warehouse Location" ar="موقع المستودع" subtle data-id="element-572" />
                <select className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl appearance-none" data-id="element-573">
                  <option data-id="element-574">Riyadh Main (WH-01)</option>
                  <option data-id="element-575">Jeddah Port (WH-02)</option>
                  <option data-id="element-576">Dammam Hub (WH-03)</option>
                </select>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-577">
                <div className="space-y-2" data-id="element-578">
                  <BilingualText en="Total Cartons" ar="إجمالي الكراتين" subtle data-id="element-579" />
                  <input type="number" placeholder="0" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl" data-id="element-580" />
                </div>
                <div className="space-y-2" data-id="element-581">
                  <BilingualText en="Total Pallets" ar="إجمالي الطبالي" subtle data-id="element-582" />
                  <input type="number" placeholder="0" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl" data-id="element-583" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-584">
                <BilingualText en="Upload Documents (Invoice/Packing List)" ar="تحميل المستندات (الفاتورة / قائمة التعبئة)" subtle data-id="element-585" />
                <div className="border-2 border-dashed border-slate-200 rounded-xl p-8 flex flex-col items-center justify-center gap-3 bg-slate-50 text-slate-400" data-id="element-586">
                  <Upload size={32} data-id="element-587" />
                  <BilingualText en="Tap to upload files" ar="اضغط لتحميل الملفات" className="text-center" data-id="element-588" />
                </div>
              </div>
            </div>

            <button onClick={() => setStep(2)} className="btn-primary w-full py-4 mt-8" data-id="element-589">
              <BilingualText en="Next: Select Appointment" ar="التالي: اختيار الموعد" className="text-white" data-id="element-590" />
            </button>
          </div>}

        {step === 2 && <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4" data-id="element-591">
            <BilingualText en="Select Appointment" ar="اختر الموعد" className="text-xl" data-id="element-592" />

            <div className="space-y-4" data-id="element-593">
              <div className="grid grid-cols-4 gap-2" data-id="element-594">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, i) => <button key={day} className={`p-3 rounded-xl border flex flex-col items-center gap-1 ${i === 2 ? 'border-[#2E3192] bg-blue-50' : 'border-slate-200'}`} data-id="element-595">
                      <span className="text-xs font-bold text-slate-400 uppercase" data-id="element-596">
                        {day}
                      </span>
                      <span className="text-lg font-bold" data-id="element-597">1{i + 2}</span>
                    </button>)}
              </div>

              <div className="space-y-3 pt-4" data-id="element-598">
                <BilingualText en="Available Time Slots" ar="الفترات الزمنية المتاحة" subtle data-id="element-599" />
                <div className="grid grid-cols-2 gap-3" data-id="element-600">
                  {['08:00 AM', '09:30 AM', '11:00 AM', '01:30 PM', '03:00 PM', '04:30 PM'].map((time, i) => <button key={time} className={`p-4 rounded-xl border text-center font-medium ${i === 1 ? 'border-[#2E3192] bg-blue-50 text-[#2E3192]' : 'border-slate-200 text-slate-600'}`} data-id="element-601">
                      {time}
                    </button>)}
                </div>
              </div>

              <div className="p-4 bg-yellow-50 border border-yellow-100 rounded-xl flex gap-3" data-id="element-602">
                <Clock className="text-yellow-600 shrink-0" size={20} data-id="element-603" />
                <BilingualText en="Capacity is 85% full for this day. Book soon to secure your slot." ar="السعة ممتلئة بنسبة 85٪ لهذا اليوم. احجز قريباً لتأمين مكانك." className="text-sm text-yellow-800" data-id="element-604" />
              </div>
            </div>

            <div className="flex gap-3 pt-8" data-id="element-605">
              <button onClick={() => setStep(1)} className="btn-secondary flex-1 py-4" data-id="element-606">
                <BilingualText en="Back" ar="رجوع" data-id="element-607" />
              </button>
              <button onClick={() => setStep(3)} className="btn-primary flex-[2] py-4" data-id="element-608">
                <BilingualText en="Confirm Booking" ar="تأكيد الحجز" className="text-white" data-id="element-609" />
              </button>
            </div>
          </div>}

        {step === 3 && <div className="text-center space-y-6 py-12 animate-in zoom-in-95 duration-500" data-id="element-610">
            <div className="w-24 h-24 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-611">
              <CheckCircle2 size={48} data-id="element-612" />
            </div>
            <div className="space-y-2" data-id="element-613">
              <BilingualText en="Shipment Created Successfully!" ar="تم إنشاء الشحنة بنجاح!" className="text-2xl" data-id="element-614" />
              <BilingualText en="Your appointment is pending warehouse approval." ar="موعدك بانتظار موافقة المستودع." subtle data-id="element-615" />
            </div>

            <div className="card p-6 text-left space-y-4 bg-slate-50 border-none" data-id="element-616">
              <div className="flex justify-between items-center" data-id="element-617">
                <BilingualText en="Booking Reference" ar="مرجع الحجز" subtle data-id="element-618" />
                <span className="font-bold" data-id="element-619">#ASN-98255</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-620">
                <BilingualText en="Date & Time" ar="التاريخ والوقت" subtle data-id="element-621" />
                <span className="font-bold" data-id="element-622">Wed, July 15 • 09:30 AM</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-623">
                <BilingualText en="Warehouse" ar="المستودع" subtle data-id="element-624" />
                <span className="font-bold" data-id="element-625">Riyadh Main (WH-01)</span>
              </div>
            </div>

            <button onClick={() => navigate('/')} className="btn-primary w-full py-4 mt-8" data-id="element-626">
              <BilingualText en="Go to Dashboard" ar="الذهاب إلى لوحة التحكم" className="text-white" data-id="element-627" />
            </button>
          </div>}
      </div>
    </div>;
}